import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import theme from '../theme';

const LandscapeMessage = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, ${props => props.theme.colors.background} 0%, #f8f9ff 100%);
  color: ${props => props.theme.colors.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 9999;
  padding: 40px 20px;
  box-sizing: border-box;
  font-family: ${props => props.theme.fonts.body};
`;

const ContentContainer = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border-radius: ${props => props.theme.borderRadius.large};
  padding: 40px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(17, 14, 27, 0.1);
  border: 2px solid ${props => props.theme.colors.accent1};
  position: relative;
`;

const Icon = styled(motion.div)`
  font-size: 4rem;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, ${props => props.theme.colors.secondary} 0%, #e8316d 100%);
  border-radius: 50%;
  color: white;
  font-size: 2.5rem;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  margin-bottom: 16px;
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.heading};
  word-break: break-word;
`;

const Message = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 24px;
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.body};
`;

const Instruction = styled.p`
  font-size: 0.9rem;
  color: ${props => props.theme.colors.secondary};
  font-weight: 600;
  background: linear-gradient(135deg, ${props => props.theme.colors.accent2} 0%, ${props => props.theme.colors.accent1} 100%);
  padding: 12px 20px;
  border-radius: ${props => props.theme.borderRadius.medium};
  margin: 0;
  display: inline-block;
`;

const LandscapeModeMessage = () => {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const checkViewportWidth = () => {
      // Use screen.width (physical screen width) instead of innerWidth to avoid zoom issues
      // Also check if device is in landscape mode with small height
      const screenWidth = window.screen.width || window.innerWidth;
      const isSmallDevice = screenWidth < 350;
      
      // TODO: Potentially fix this later
      setShowMessage(false);
    };

    // Check on mount
    checkViewportWidth();

    // Add event listener for resize and orientation change
    window.addEventListener('resize', checkViewportWidth);
    window.addEventListener('orientationchange', checkViewportWidth);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkViewportWidth);
      window.removeEventListener('orientationchange', checkViewportWidth);
    };
  }, []);

  if (!showMessage) return null;

  return (
    <LandscapeMessage
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <ContentContainer>
        
        <Icon
          animate={{ 
            rotate: [0, 90, 0],
            scale: [1, 1.1, 1]
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          📱
        </Icon>
        
        <Title>Bitte drehe dein Smartphone</Title>
        
        <Message>
          Drehe bitte dein Smartphone ins Querformat um MeyTeaches richtig anzeigen zu können.
        </Message>
      </ContentContainer>
    </LandscapeMessage>
  );
};

export default LandscapeModeMessage;
